<style lang="scss">
  @use "../../../../assets/css/design-system/mixins";
  @use "../../../../assets/css/design-system/colors";
  @use "../../../../assets/css/design-system/utils";

  .date-heading {
    height: utils.in_rem(60px);
    line-height: utils.in_rem(20px);
    padding: utils.in_rem(20px) utils.in_rem(20px);
    font-size: utils.in_rem(16px);
    font-weight: 600;
    @include colors.color(textBlack);
  }
</style>

<script>
  import { getDatePickerContext } from "../DatePicker/context.svelte.js";

  const datePickerContext = getDatePickerContext();
</script>

<div class="date-heading">
  {datePickerContext?.modalTitle || "Select date"}
</div>
